module.exports = __webpack_public_path__ + "static/media/logo-white-1.832c301d.png";